module.exports = __webpack_public_path__ + "img/american-express.95d90330.png";